import { CustomerType } from "@origin-digital/platform-enums";
import { CommonParameters, IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const paymentHistory: IMcAppType = {
  name: "paymentHistory_SAP",
  path: "/my-account/billing-payment/payment-history",
  description: "History of payments",
  parameters: {
    required: ["caid"],
    properties: { caid: CommonParameters.caid },
  },
  navFlow: NavFlow.STANDARD,
  title: "Payment History",
  parent: Tab.MORE,
  conditions: {
    intent: "paymentHistory",
    customerType: CustomerType.sap,
  },
};

export const paymentHistory_KRAKEN: IMcAppType = {
  name: "paymentHistory_KRAKEN",
  path: "/my/bills-payments/:accountNumber?",
  description: "History of transactions",
  parameters: {
    properties: { accountNumber: CommonParameters.accountNumber },
  },
  navFlow: NavFlow.STANDARD,
  title: "Bills and Payments",
  parent: Tab.MORE,
  conditions: {
    intent: "paymentHistory",
    customerType: CustomerType.kraken,
  },
};
